export default __webpack_public_path__ + "static/media/mrinner.aa691343.svg";